import type { ID } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { useGenerateProject } from '@/hooks/ai'
import { getValuableBlockTitles } from '@/hooks/ai/utils'

export const useGeneratePages = (nodeId: ID) => {
  const generateProject = useGenerateProject({ parentId: nodeId })

  // The page's block titles prefill the prompt as page names.
  const initial = useSelector((state: AppState) =>
    getValuableBlockTitles(state, nodeId)
      // @TODO review this and fix
      // @ts-expect-error - Property 'title' does not exist on type 'Block'
      .map((block) => block.title)
      .join(', ')
  )

  const onGenerate = (prompt: string) => {
    sendGtmEvent(
      GtmTriggerName.AI_PAGE_GENERATE,
      'Click to generate child pages by AI'
    )

    generateProject(prompt)
  }

  return { initial, onGenerate }
}
